import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ServisniPaketyPp = {
	name: NAME,
	apiProvider,
	router,
};
